import React from 'react';
import { Box } from '@mui/material';
import { AU, FUENTE, LINEA_SOBRE_AZUL, SOMBRA_TARJETA } from '../../styles/tokensAU';
import { formatFechaConOffset } from '../../utils/fechaSuscripcion';
import { formatoCLP } from '../../utils/montoCLP';
import ErrorConCodigo from '../ErrorConCodigo';
import EtiquetaAU from './EtiquetaAU';
import PildoraAU from './PildoraAU';
import TarjetaAU from './TarjetaAU';

// Dato del pie: la etiqueta en azul suave (4,73:1 sobre azulHover) y el valor en blanco.
const Dato = ({ etiqueta, children }) => (
  <Box component="span">
    <Box component="span" sx={{ color: AU.azulSuave }}>{`${etiqueta} `}</Box>
    <Box component="span" sx={{ fontWeight: 600 }}>{children}</Box>
  </Box>
);

// El plan en una tarjeta rellena de azul (blanco sobre azulHover = 5,23:1, pasa AA también para el texto
// chico): encabezado con el ciclo, el monto como titular y un pie con inicio y renovación que la cierra.
const TarjetaPlan = ({ monto, cargando, error, inicio }) => {
  // Un monto 0 (o ausente) no es un cobro válido: se trata como "no disponible", nunca como un "0" suelto.
  const hayMonto = Boolean(monto);
  // "miércoles 30 de septiembre" → "30 de septiembre": en el pie no cabe el día de la semana en celular.
  const fechaInicio = formatFechaConOffset(inicio)?.split(' ').slice(1).join(' ');
  return (
  <TarjetaAU aria-label="Plan" sx={{ bgcolor: AU.azulHover, color: AU.blanco, boxShadow: SOMBRA_TARJETA, py: { xs: 2.5, sm: 3 } }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
      <EtiquetaAU component="div" sx={{ color: AU.azulSuave }}>Tu plan</EtiquetaAU>
      <PildoraAU sx={{ bgcolor: AU.blanco }}>Cada 30 días</PildoraAU>
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mt: 1.25, flexWrap: 'wrap' }}>
      {cargando && (
        <Box role="status" aria-label="Cargando el monto" sx={{ width: 180, height: 46, borderRadius: '8px', bgcolor: AU.azul }} />
      )}
      {!cargando && hayMonto && (
        <>
          <Box component="span" sx={{ fontFamily: FUENTE, fontSize: { xs: 40, sm: 44 }, fontWeight: 800, lineHeight: 1.05, color: AU.blanco }}>
            {formatoCLP(monto)}
          </Box>
          <Box component="span" sx={{ fontFamily: FUENTE, fontWeight: 600, color: AU.azulSuave }}>CLP</Box>
        </>
      )}
      {!cargando && !hayMonto && (
        <Box component="span" sx={{ fontFamily: FUENTE, fontSize: 18, fontWeight: 700, color: AU.azulSuave }}>Monto no disponible</Box>
      )}
    </Box>
    <Box
      sx={{
        mt: 2,
        pt: 1.5,
        borderTop: `1px solid ${LINEA_SOBRE_AZUL}`,
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        columnGap: 2,
        rowGap: 0.5,
        fontFamily: FUENTE,
        fontSize: 14,
        color: AU.blanco,
      }}
    >
      {fechaInicio ? <Dato etiqueta="Inicio">{fechaInicio}</Dato> : <span />}
      <Dato etiqueta="Renueva">cada 30 días</Dato>
    </Box>
    {error && <Box sx={{ mt: 1.5 }}><ErrorConCodigo mensaje={error} /></Box>}
  </TarjetaAU>
  );
};

export default TarjetaPlan;
